import { CombinedGraphQLErrors, LinkError } from '@apollo/client/errors'
import { getNetworkStatusCode } from 'lib/helpers/getNetworkStatusCode/getNetworkStatusCode'

/**
 * True only when a request failed to reach the server at all — no HTTP response
 * (offline, DNS/TLS failure, or blocked by a firewall/VPN/extension). An error
 * carrying a statusCode means the server DID respond (e.g. a 5xx), so that is
 * not treated as unreachable. GraphQL errors also imply the server was reached.
 *
 * Gated on the error having come from the link chain, so an unrelated `Error`
 * thrown by application code never reads as a connectivity problem.
 */
export const isNetworkError = (error: unknown): boolean =>
  LinkError.is(error) && !CombinedGraphQLErrors.is(error) && getNetworkStatusCode(error) === undefined
